import { render, staticRenderFns } from "./app-page.vue?vue&type=template&id=64004f2a&scoped=true&"
import script from "./app-page.vue?vue&type=script&lang=js&"
export * from "./app-page.vue?vue&type=script&lang=js&"
import style0 from "./app-page.vue?vue&type=style&index=0&id=64004f2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64004f2a",
  null
  
)

export default component.exports